
import { Vue, Prop, Component } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import BarcodeOrderModule from "@/store/modules/barcodeSystem/barcodeOrder";
import { TransactionResouce } from "@/models/api/barcodeSystem/transactions/get";
import { formatDateWithTime, formatBool } from "@/utils";

const barcodeOrderModuleState = getModule(BarcodeOrderModule);

@Component
export default class TranactionTable extends Vue {
  @Prop({ default: false })
  loading: boolean;

  @Prop({default: null })
  orderItemId: number | null;

  get transactions(): Array<TransactionResouce> {
    return barcodeOrderModuleState.currentBarcodeOrderTransactions;
  }

  get filteredTransactions(): Array<TransactionResouce> {
    return barcodeOrderModuleState.currentBarcodeOrderTransactions ? barcodeOrderModuleState.currentBarcodeOrderTransactions.filter(x => this.orderItemId == null || x.orderItemId == this.orderItemId) : null;
  }

  getComponentData(rowData) {
    return {
      on: {
        dblclick: () => this.onDoubleClicked(rowData)
      }
    };
  }

  formatDateWithTime(val)
  {
    return formatDateWithTime(val)
  }

  formatBool(val)
  {
    return formatBool(val);
  }

  onDoubleClicked(data) {
  }

  onRowClick(data) {
  }

  unselectAll() {
  }
}
